import ReportTitle from './ReportTitle';
export default ReportTitle;